<template>
  <v-tabs-items
    v-bind:value="value"
    v-bind:touchless="isTouchless"
    v-on:change="emitInput">
    <slot
      v-if="isStatic"
    />
    <tab-item
      v-else
      v-for="(item, itemIndex) in items"
      v-bind:key="itemIndex"
      v-bind:index="itemIndex"
      v-bind:tab-class="tabClass"
    >
      <slot v-bind="{ item, itemIndex }" />
    </tab-item>
  </v-tabs-items>
</template>

<script>

import TabItem from '@/components/TabItem.vue';

/**
 * @description Контент вкладок.
 * @type {Vue}
 */
export default {
  name: 'TabsItems',
  components: { TabItem },
  methods: {
    emitInput(index) {
      this.$emit('input', index);
    },
  },
  props: {
    isStatic: { default: () => false, type: Boolean },
    /**
     * @description Поддержка сенсорных жестов.
     * @type {Bool}
     */
    isTouchless: { default: () => false, type: Boolean },
    /**
     * @description Элементы.
     * @type {Object[]}
     */
    items: { required: true, type: Array },
    /**
     * @description Значение аттрибута класса для вкладки.
     * @type {string}
     */
    tabClass: {
      default: () => '',
      required: false,
      type: String,
    },
    /**
     * @description Индекс показываемой вкладки.
     * @type {Number}
     */
    value: { default: () => null, type: [Number, Object] },
  },
};
</script>

<style>

</style>
